import { drivers } from '../config';
export = drivers['better-sqlite3'];
